import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import auth from './store/auth'
import {Trans} from '@/plugins/Translation'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  beforeEnter: Trans.routeMiddleware,
  routes: [
    {
      path: '*',
      name: 'Not found',
      redirect() {
        return Trans.currentLocale;
      }
    },
    {
      path: '/:locale/login',
      name: 'login',
      meta: { layout: 'empty' },
      component: () => import('@/views/Login')
    },
    {
      path: '/:locale/register',
      name: 'register',
      meta: { layout: 'empty' },
      component: () => import('@/views/Register')
    },
    {
      path: '/:locale/success-register',
      name: 'success-register',
      component: () => import('@/views/SuccessRegister')
    },
    {
      path: '/:locale/',
      name: 'home',
      component: () => import('@/views/Home')
    },
    {
      path: '/:locale/create-npa',
      name: 'create-npa',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/CreateNpa')
    },
    {
      path: '/:locale/search-npa',
      name: 'search-npa',
      component: () => import('@/views/SearchNpa')
    },
    {
      path: '/:locale/view-npa/:id',
      name: 'view-npa',
      component: () => import('@/views/NpaViewSearch')
    },
    {
      path: '/:locale/profile',
      name: 'profile',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/Profile')
    },
    {
      path: '/:locale/notification-view/:id',
      name: 'notification-view',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/NotificationView')
    },
    {
      path: '/:locale/profile/settings',
      name: 'profile-settings',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/ProfileSettings')
    },
    {
      path: '/:locale/complaints',
      name: 'complaints',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/Complaints')
    },
    {
      path: '/:locale/comments',
      name: 'my-comments',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/MyComments')
    },
    {
      path: '/:locale/answers',
      name: 'my-answers',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/MyAnswers')
    },
    {
      path: '/:locale/my-npa',
      name: 'my-npa',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/MyNpa')
    },
    {
      path: '/:locale/article/:slug',
      name: 'article',
      component: () => import('@/views/Article')
    },
    {
      path: '/:locale/blog/:slug',
      name: 'blog',
      component: () => import('@/views/Blog')
    },
    {
      path: '/:locale/npa/categories',
      name: 'npa_categories',
      component: () => import('@/views/NpaCategories')
    },
    {
      path: '/:locale/npa/developers',
      name: 'npa_developers',
      component: () => import('@/views/NpaDevelopers')
    },
    {
      path: '/:locale/npa/:slug',
      name: 'npa',
      component: () => import('@/views/Npa')
    },
    {
      path: '/:locale/npa-view/:id',
      name: 'npa-view',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/NpaView')
    },
    {
      path: '/:locale/offer',
      name: 'offer-list',
      component: () => import('@/views/Offer')
    },
    {
      path: '/:locale/offer-create',
      name: 'offer-create',
      meta: {
        requiresAuth: true
      },
      component: () => import('./views/OfferCreate')
    },
    {
      path: '/:locale/offer-view/:id',
      name: 'offer-view',
      component: () => import('./views/OfferView')
    },
    {
      path: '/:locale/send-email',
      name: 'send-email',
      component: () => import('./views/SendEmail')
    },
    {
      path: '/:locale/confirm-email/:token',
      name: 'confirm-email',
      component: () => import('./views/ConfirmEmail')
    },
    {
      path: '/:locale/password-reset',
      name: 'password-reset',
      component: () => import('./views/PasswordReset')
    },
    {
      path: '/:locale/password-reset/:token',
      name: 'password-reset-token',
      component: () => import('./views/PasswordResetToken')
    },
    {
      path: '/:locale/subscriptions',
      name: 'my-subscriptions',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/MySubscriptions')
    },
    {
      path: '/:locale/law',
      name: 'law',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('./views/Law')
    },
    {
      path: '/:locale/law/statistic',
      name: 'law-statistic',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('./views/LawStatistic')
    },
    {
      path: '/:locale/law/statistic/:type',
      name: 'law-statistic-details',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('./views/LawStatisticDetails')
    },
    {
      path: '/:locale/create-law',
      name: 'create-law',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('./views/CreateLaw')
    },
    {
      path: '/:locale/law-view/:id',
      name: 'law-view',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/LawView')
    },
    {
      path: '/:locale/law-norm-view/:id',
      name: 'law-norm-view',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/LawNormView')
    },
    {
      path: '/:locale/law-view/create-norm/:id',
      name: 'create-norm',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/LawNormCreate')
    },
    {
      path: '/:locale/law-view/edit-norm/:id',
      name: 'edit-norm',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/NormEdit')
    },
    {
      path: '/:locale/solution-edit/:id',
      name: 'solution-edit',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/SolutionsEdit')
    },
    {
      path: '/:locale/law-list/:slug',
      name: 'law-list',
      component: () => import('@/views/LawSearch')
    },
    {
      path: '/:locale/enforcement-law',
      name: 'enforcement-law',
      component: () => import ('@/views/EnforcementLaw')
    },
    {
      path: '/:locale/feedback/add',
      name: 'feedback-add',
      component: () => import('@/views/Feedback')
    },
    {
      path: '/:locale/feedback-success/:id',
      name: 'feedback-success',
      component: () => import('@/views/FeedbackSuccess')
    },
    {
      path: '/:locale/appeal-statistics',
      name: 'AppealStatistics',
      component: () => import('@/views/AppealStatistics')
    },
    {
      path: '/:locale/appeal/:id',
      name: 'appeal',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/Appeal')
    },
    {
      path: '/:locale/users',
      name: 'users',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/Users')
    },
    {
      path: '/:locale/user/new',
      name: 'user_new',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/User/EditView')
    },
    {
      path: '/:locale/user/view/:id',
      name: 'user-view',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/User/View')
    },
    {
      path: '/:locale/appeals',
      name: 'appealsList',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/AppealsList')
    },
    {
      path: '/:locale/error/:status',
      name: 'error',
      component: () => import('@/views/Error')
    },
    {
      path: '/:locale/my-offers',
      name: 'my-offers',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/MyOffers')
    },
    {
      path: '/:locale/comment-statistics/:id',
      name: 'comment-statistics',
      component: () => import('@/views/CommentStatistics')
    },
    {
      path: '/:locale/rating-list',
      name: 'rating-list',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/RatingList')
    },
    {
      path: '/:locale/statistics',
      name: 'statistics',
      component: () => import('@/views/Statistics/List')
    },
    {
      path: '/:locale/developer-statistics',
      name: 'developer-statistics',
      component: () => import('@/views/Statistics/DeveloperList')
    },
    {
      path: '/:locale/category-statistics',
      name: 'category-statistics',
      component: () => import('@/views/Statistics/CategoryList')
    },
  ]
})

router.beforeEach((to, from, next) => {
  Trans.routeMiddleware(to, from, next)
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    sessionStorage.setItem('redirectPath', to.path)
    next(Trans.currentLocaleUrl + '/login')
  } else {
    next()
  }
})

export default router
